export const SESSION = {
	SESSION_KEY_USER: "userDetails",
	/** Unix ms; extends on login and successful GET /auth/me — used for offline session validity */
	SESSION_KEY_OFFLINE_SESSION_EXPIRES_AT: "offlineSessionExpiresAt",
	SESSION_KEY_USER_ROLE: "userRole",
	SESSION_KEY_MASTER_DATA: "masterData",
	SESSION_KEY_CANDIDATES: "candidatesList",
	SESSION_KEY_FORM_MASTER_DATA: "formMasterData",
	SESSION_KEY_PROFILE: "profileData",
	/** Post-login redirect target; stored in sessionStorage (cleared after use) */
	SESSION_KEY_RETURN_URL: "returnUrl",
	/**
	 * Emergency backup of unsynced eTrainingDB drafts before IndexedDB version reset.
	 * Cleared after successful restore into a healthy DB.
	 */
	SESSION_KEY_UNSYNCED_DRAFT_BACKUP: "eTrainingUnsyncedDraftBackup",
};

/** Must match cbta-backend auth.guard BFF session 401 message. */
export const BFF_SESSION_REQUIRED_MESSAGE =
	"CBTA session required. Please sign in again.";

/** Login query flag set when interceptor redirects after BFF session 401. */
export const LOGIN_SESSION_UPGRADE_QUERY = "sessionUpgrade";

/** Login URL that triggers pending service-worker refresh (logout, session expiry). */
export function loginPathWithSessionUpgrade(loginSegment = "login"): string {
	return `/${loginSegment}?${LOGIN_SESSION_UPGRADE_QUERY}=1`;
}

/** sessionStorage guard for one-shot SW cache bust on logout / session expiry. */
export const SW_SESSION_UPGRADE_STORAGE_KEY = "cbta_sw_session_upgrade";

/** Values: "1" = reload pending; "handled" = refresh already applied this visit chain. */
export const SW_SESSION_UPGRADE_PENDING = "1";
export const SW_SESSION_UPGRADE_HANDLED = "handled";
